import { 
    CHANGERECONDATA,
    LOADRECONDATA,
    RESETRECONDATA,
    SELECTALLRECONDATA,
    SET_NOTIFICATION
} from "../constant/constant";
import { pAxios } from "..";

// Service to load recon data
export function loadReconDataService(date) {
    return new Promise(function (resolve, reject) {
        pAxios({
            "method": "GET",
            "url": `/api/recon/details?date=${date}`,
            "headers": {
                'content-type': 'application/json'
            }
        }).then(response => {
            if (response.data) {
                resolve({ type: LOADRECONDATA, reconData: response.data });
            }
        })
        .catch(err => {
            reject({ type: SET_NOTIFICATION, notification: { message: "Failed to load recon data", variant: "danger", err } });
        });
    });
}


export function saveReconService(data,method){

  return new Promise(function (resolve, reject) {

      pAxios({
          "method": "POST",
          "url": `/api/recon`,
          "headers": {
              'content-type': 'application/json'
          },
          "data":JSON.stringify(data)
        
      }).then(response => {

         if(response.data){
               
        //   store.dispatch({
            // type: SET_NOTIFICATION, notification:
                resolve({ message: `Recon successfull`, variant: "success", err: "" })
            // });
            // resolve({ type: RESETPROJECT});
         }
      })
          .catch(err => {
              
              reject({ message:"Failed to recon ",variant:"danger",err}  )
          });
  });

}

export function getLastProcessService(){

  return new Promise(function (resolve, reject) {

      pAxios({
          "method": "GET",
          "url": `/api/recon/last`,
          "headers": {
              'content-type': 'application/json'
          }
        
      }).then(response => {

         if(response.data){
               
        //   store.dispatch({
            // type: SET_NOTIFICATION, notification:
                resolve({...response.data })
            // });
            // resolve({ type: RESETPROJECT});
         }
      })
          .catch(err => {
              
              reject({ message:"Failed to load last recon ",variant:"danger",err}  )
          });
  });

}


// Action to load recon data
export const loadReconData = (date) => {
    return dispatch => {
        loadReconDataService(date)
            .then(response => dispatch(response))
            .catch(err => dispatch(err));
    }
}


// Action to reset recon data
export const resetReconData = () => {
    return dispatch => {
        dispatch({ type: RESETRECONDATA });
    }
}

export const changeReconDate = (id) => {
    return dispatch =>{
        dispatch({ type: CHANGERECONDATA, id})
    }
}

export const selectAllReconData = (selectAll) => {
    return dispatch => {
        dispatch({ type: SELECTALLRECONDATA, selectAll })
    }
}

